import { render, staticRenderFns } from "./FirmwareVersionsView.vue?vue&type=template&id=5050e998&scoped=true"
import script from "./FirmwareVersionsView.vue?vue&type=script&lang=ts"
export * from "./FirmwareVersionsView.vue?vue&type=script&lang=ts"
import style0 from "./FirmwareVersionsView.vue?vue&type=style&index=0&id=5050e998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5050e998",
  null
  
)

export default component.exports